import { useMemo } from "react";
import { usePagination, useSearch, useSorting } from "@/hooks";
import { GetVehicleTypesParams } from "@/redux/apis/config/trip/vehicleType/types";

export const useGetVehicleTypesParams = () => {
  const { page, pageSize } = usePagination("config-vehicle-types", 25);
  const { sorting, setSorting, sortKey, direction } = useSorting();
  const [search, setSearch] = useSearch();

  const params: GetVehicleTypesParams = useMemo(
    () => ({
      page,
      page_size: pageSize,
      sort: sortKey,
      direction,
      search,
    }),
    [page, pageSize, sortKey, direction, search]
  );

  return {
    params,
    sorting,
    setSorting,
    sortKey,
    direction,
    search,
    setSearch,
  };
};
